import { uploadFile } from "../redux/apis/common";

export const handleUploadFile = async (data) => {
    try {
        const config = { headers: { 'Content-Type': 'multipart/form-data' } }

        const response = await uploadFile(data, config)
        return response;

    } catch (error) {
        throw new Error(error)
    }
}